import { EPurchaseTypes } from 'entities/Source';
import { i18n } from 'i18n';

export const PURCHASE_TYPES = () => ({
	[EPurchaseTypes.SOCIAL_MEDIA_ADS]: i18n.t('Реклама в социальных сетях'),
	[EPurchaseTypes.SEARCH_ENGINE_ADS]: i18n.t('Реклама в поисковиках'),
	[EPurchaseTypes.OTHERS]: i18n.t('Другое'),
});
